import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { MainService } from '../../service/main.service';
import { MatTableDataSource } from '@angular/material/table';
import { ComplaintsService } from '../../service/complaints.service'
import { session } from '../../../../environments/environment.session';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SpinnerService } from '../../../shared/spinner.service'
import { DomSanitizer } from "@angular/platform-browser";
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { PdfGeneratorService } from '../../service/pdf-generator.service';
import { TranslationService } from '../../service/translation.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements AfterViewInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  // searchTerm: any ;
 
  displayedColumns: string[] = ['sno', 'id', 'dept', 'zone', 'fullName', 'mobileNo', 'created', 'days_Open', 'action'];
 
  dataSource: any = [];
  dashPrevFlag = false
  dashFilePrevFlag = true
  // searchTerm: string = '';

  complaints: any = new MatTableDataSource(this.dataSource);
  constructor(private pdfService: PdfGeneratorService, private cs: ComplaintsService, public mainService: MainService, private tspinner: SpinnerService, private sanitizer: DomSanitizer, private router: Router, public translation: TranslationService) { }




  erpUser: any
  async ngOnInit() {
    this.erpUser = JSON.parse(atob(session.erpUser));
    this.complaints.filterPredicate = (data: any, filter: any) => {
      const dataStr = Object.values(data).join('').toLowerCase();
      return dataStr.includes(filter);
    };
    this.tspinner.show('', '')
    await this.getComplaints()
    this.tspinner.hide()

  }

  applyFilter(filterValue: string) {
    this.complaints.filter = filterValue.trim().toLowerCase();
  }
  onDownloadPDF(element: any) {
    const b_acct_id = this.erpUser.b_acct_id;
    this.pdfService.generateComplaintPDF(b_acct_id, element.com_id);
  }
  department = {}
  total_complaints = 0
  async getComplaints() {
    let obj = { b_acct_id: this.erpUser.b_acct_id, filter: 'recet', count: true};
    let resp = await this.cs.getComplaints(JSON.stringify(obj));
    if (resp['error'] == false) {
      resp.data.map((complaint: any) => {
        try {
          const deptArray = JSON.parse(complaint.dept || '[]');
          complaint.departments = deptArray.map((item: any) => Object.values(item));
        } catch (err) {
          complaint.departments = [];
        }
        return complaint;
      });


      if (resp['total_complaints']) {
        this.total_complaints = resp['total_complaints']
      }
      this.complaints = new MatTableDataSource(resp['data']);
      this.complaints.sort = this.sort;
      this.complaints.paginator = this.paginator;
    } else {

    }

  }

  prevViewFileObj: any = {}
  prevViewFile(element: any) {
    this.dashFilePrevFlag = false
    this.dashPrevFlag = true
    this.prevViewFileObj = element
  }

  back() {
    this.dashFilePrevFlag = true
    this.dashPrevFlag = false
  }


  imgURL: any
  async viewDoc(obj: any, doc: any, doc_type: string) {
    if (obj[doc]) {
      this.tspinner.show('', '')
      let ob = { b_acct_id: this.erpUser.b_acct_id, doc_name: obj[doc], doc_type: doc_type, doc_id: obj.com_id }
      const res = await this.cs.viewDoc(ob);
      if (res) {
        var docname = obj[doc];
        var ext = docname.split(".");
        if (
          ext[1] == "png" ||
          ext[1] == "jpeg" ||
          ext[1] == "jpg" ||
          ext[1] == "PNG" ||
          ext[1] == "JPEG" ||
          ext[1] == "JPG"
        ) {
          let file = new Blob([res], { type: "image/png" });
          var fileURL = window.URL.createObjectURL(file);
          this.imgURL = this.sanitizer.bypassSecurityTrustUrl(fileURL);
          this.tspinner.hide();
          window.open(fileURL, "_blank");
        } else if (ext[1].toLowerCase() == "xlsx") {
          let file = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.tspinner.hide();
        } else if (
          ext[1].toLowerCase() == "docx" ||
          ext[1].toLowerCase() == "doc"
        ) {
          let file = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.tspinner.hide();
        } else {
          let file = new Blob([res], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.tspinner.hide();
        }
      } else {
        this.tspinner.hide();
      }
    } else {
      this.tspinner.hide();
      swal.fire("Error", "No document Uploaded !", "error");
    }
  }

  route(element: any) {
    this.router.navigate(['/sdp/complaints/preview'], {
      state: { data: element }
    });
  }
  ngAfterViewInit(): void {
    this.mainService.dataSource = this.complaints
  }





}
